import foldableSearchUrl from './foldableSearch.html';

class FoldableSearchCtrl {
  constructor($scope) {
    'ngInject';

    Object.assign(this, { $scope });
  }

  performSearch() {
    this.$scope.$applyAsync(() => {
      this.onSearch({ searchText: this.searchText });
    });
  }
}

export default {
  templateUrl: foldableSearchUrl,
  controller: FoldableSearchCtrl,
  controllerAs: 'ctrl',
  bindings: {
    searchText: '=?',
    onSearch: '&',
    borderlessCollapsed: '<?',
    debounce: '<?',
  },
};
